import { Component, input } from '@angular/core';
import { SharedModule } from '@app/modules/shared.module';
import { Sommeil } from '@app/models/carnet-liaison';
import { CarnetHeureFormatPipe, CarnetDureeFormatPipe } from '../../carnet-liaison.pipe';

@Component({
  selector: 'app-carnet-sommeil',
  templateUrl: './carnet-sommeil.component.html',
  styleUrl: './carnet-sommeil.component.scss',
  standalone: true,
  imports: [SharedModule, CarnetHeureFormatPipe, CarnetDureeFormatPipe],
})
export class CarnetSommeilComponent {
  data = input.required<Sommeil>();

  getSiestes() {
    return this.data()?.ongletSommeil?.zr_sommeil?.filter(s => s.input_heure) ?? [];
  }
}
